export const Healthcare = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 6.50006C5.56333 -1.4222 -6.7569 9.28789 11.4545 21.1501C11.7778 21.3606 12.2227 21.3606 12.546 21.1501C30.7574 9.28789 18.4371 -1.4222 12.0002 6.50006Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M6.5 12.5V13.25H6.92464L7.14312 12.8859L6.5 12.5ZM12.5 12.5V11.75H11.9594L11.7885 12.2628L12.5 12.5ZM15.5 13.25C15.9142 13.25 16.25 12.9142 16.25 12.5C16.25 12.0858 15.9142 11.75 15.5 11.75V12.5V13.25ZM11.3872 15.3227L10.7545 15.7254L11.3872 15.3227ZM11.5664 15.3007L12.278 15.5379L11.5664 15.3007ZM7.91675 10.1387L8.55987 10.5246L7.91675 10.1387ZM8.08687 10.1365L8.71961 9.73385L8.08687 10.1365ZM3 12.5V13.25H6.5V12.5V11.75H3V12.5ZM6.5 12.5L7.14312 12.8859L8.55987 10.5246L7.91675 10.1387L7.27363 9.75287L5.85688 12.1141L6.5 12.5ZM8.08687 10.1365L7.45412 10.5392L10.7545 15.7254L11.3872 15.3227L12.0199 14.9201L8.71961 9.73385L8.08687 10.1365ZM11.5664 15.3007L12.278 15.5379L13.2115 12.7372L12.5 12.5L11.7885 12.2628L10.8549 15.0635L11.5664 15.3007ZM12.5 12.5V13.25H15.5V12.5V11.75H12.5V12.5ZM11.3872 15.3227L10.7545 15.7254C11.1387 16.3292 12.0516 16.2169 12.278 15.5379L11.5664 15.3007L10.8549 15.0635C11.028 14.5443 11.7261 14.4583 12.0199 14.9201L11.3872 15.3227ZM7.91675 10.1387L8.55987 10.5246C8.31127 10.939 7.71354 10.9468 7.45412 10.5392L8.08687 10.1365L8.71961 9.73385C8.38037 9.20076 7.59873 9.21105 7.27363 9.75287L7.91675 10.1387Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
};
